/**
 * Bulk Delete Property Confirmation Dialog
 *
 * Confirmation dialog for deleting multiple property listings
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import type { IBulkDeleteDialogProps } from '@/@types/property';

export const BulkDeleteDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  count,
}: IBulkDeleteDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete {count} Properties?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete{' '}
            <span className="font-semibold">{count} properties</span>? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
          <p className="font-medium mb-1">Warning:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>All {count} property listings will be permanently deleted</li>
            <li>All generated videos will be deleted</li>
            <li>All video scenes and assets will be removed</li>
          </ul>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : `Delete ${count} Properties`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
